import { AnimatePresence } from "framer-motion";
import { TimeStep } from "../steps/TimeStep";
import { WakeStatusStep } from "../steps/WakeStatusStep";
import { LocationStep } from "../steps/LocationStep";
import { EnvironmentStep } from "../steps/EnvironmentStep";
import { OnsetStep } from "../steps/OnsetStep";
import { SoundStep } from "../steps/SoundStep";
import { SoundLevelStep } from "../steps/SoundLevelStep";
import { RestfulnessStep } from "../steps/RestfulnessStep";
import { SleepDebtStep } from "../steps/SleepDebtStep";
import { NotesStep } from "../steps/NotesStep";
import { StepType } from "../hooks/sleep-dialog-types";

interface SleepStepRendererProps {
  currentStep: StepType;
  selectedChild?: { name: string };
  locations: { id: string; description: string }[];
  environments: { id: string; description: string }[];
  onsetMethods: { id: string; description: string }[];
  sounds: { id: string; name: string }[];
  soundLevels: { id: string; level: string }[];
  restfulnessRatings: { id: string; description: string }[];
  nextStep: () => void;
  hasWokenUp?: string;
}

export function SleepStepRenderer({
  currentStep,
  selectedChild,
  locations,
  environments,
  onsetMethods,
  sounds,
  soundLevels,
  restfulnessRatings,
  nextStep,
  hasWokenUp
}: SleepStepRendererProps) {
  return (
    <AnimatePresence mode="wait">
      {currentStep === 'start' && (
        <TimeStep type="start" childName={selectedChild?.name} />
      )}

      {currentStep === 'wake_status' && (
        <WakeStatusStep childName={selectedChild?.name} onNext={nextStep} />
      )}

      {currentStep === 'end' && hasWokenUp === 'yes' && (
        <TimeStep type="end" childName={selectedChild?.name} />
      )}

      {currentStep === 'restfulness' && hasWokenUp === 'yes' && (
        <RestfulnessStep
          restfulnessRatings={restfulnessRatings}
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'location' && (
        <LocationStep
          locations={locations}
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'environment' && (
        <EnvironmentStep
          environments={environments}
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'onset' && (
        <OnsetStep
          onsetMethods={onsetMethods}
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'sound' && (
        <SoundStep
          sounds={sounds}
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'sound_level' && (
        <SoundLevelStep
          soundLevels={soundLevels}
          onNext={nextStep}
        />
      )}

      {currentStep === 'sleep_debt' && (
        <SleepDebtStep
          childName={selectedChild?.name}
          onNext={nextStep}
        />
      )}

      {currentStep === 'notes' && (
        <NotesStep
          childName={selectedChild?.name}
        />
      )}
    </AnimatePresence>
  );
}
